import React from "react";
import { usePermissionContext } from "../contexts/PermissionContext";

interface PermissionButtonProps {
  code?: string;
  mode: "create" | "edit";
  visible?: boolean;
  children: JSX.Element;
}

export const PermissionButton: React.FC<PermissionButtonProps> = ({ code, mode, children, visible = true }) => {
  const { permission} = usePermissionContext();
  const permissionItem = permission.find((p) => p.Code === code);
    switch (mode) {
        case 'create':
            if (!permissionItem?.CanCreate) { 
              return visible ? React.cloneElement(children, { className: children.props.className +  " disabled-button"}): null;
            }
            else
            {
                return React.cloneElement(children, { className: children.props.className});
            }          
        case 'edit':
            if (!permissionItem?.CanEdit) {
                return visible ? React.cloneElement(children, { className: children.props.className + " disabled-button"}): null;  
            }
            else
            {
                return React.cloneElement(children, { className: children.props.className});
            }           
        }   

  return children;
};